module.exports = __webpack_public_path__ + "assets/assets/images/info/icon-tooth-magnifying.5164a1f3.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/info/icon-tooth-magnifying.svg
// module id = 268
// module chunks = 0